<!-- Se muestra SOLO cuando visible = true -->
@if (visible) {
  <div
    class="uf-overlay"
    role="dialog"
    aria-modal="true"
    aria-label="Update required">
    <div class="uf-card">
      <img src="images/logo-meprestas.svg" class="logo" alt="logo" />
      <h1>Actualización requerida</h1>
      <p>Para continuar, por favor instala la última versión de la app.</p>
      <div class="actions">
        <button
          type="button"
          mat-flat-button
          color="primary"
          (click)="goUpdate()">
          Actualizar
        </button>
      </div>
    </div>
  </div>
}
